import { createSelector } from 'reselect'

const activeSelector = state => state.app.notification.active
const timeoutSelector = state => state.app.notification.timeout
const typeSelector = state => state.app.notification.type
const messageSelector = state => state.app.notification.message

export {
  activeSelector,
  timeoutSelector,
  typeSelector,
  messageSelector,
}
